import * as t from "io-ts";
import { createClientCargoTemplateTypes, isoDateTime } from "dora-contracts";

export const {
  createClientCargoTemplateReqT,
  editClientCargoTemplateReqT,
  getClientCargoTemplateResT,
  getClientsCargoTemplatesResT,
  createClientCargoTemplateResT,
} = createClientCargoTemplateTypes({
  decimal: t.string,
  date: t.string,
  dateTime: isoDateTime,
});
